<template>
  <div v-if="loading"></div>
  <div v-else>
    <v-dialog v-model="dialog" persistent max-width="800px" light>
      <v-toolbar class="custom-font-regular requerimiento-toolbar" color="#dedfe4">
        <v-toolbar-title>{{ requerimiento.nombre }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items right>
          <v-btn icon @click="hideDialog"><v-icon>close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card class="body-content">
        <RequerimientoDetail :requerimiento="currentRequerimiento" :current-status="currentRequerimiento.estadoDisplay"
                             @updateRequerimiento="updateAfterRequest" isFicha></RequerimientoDetail>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RequerimientoDetail from '../../presentacion/components/RequerimientoDetail/RequerimientoDetail'

export default {
  props: {
    requerimiento: Object
  },

  components: {
    RequerimientoDetail
  },

  data () {
    return {
      loading: true,
      dialog: true,
      currentRequerimiento: this.requerimiento
    }
  },

  methods: {
    fetchRequerimientoDraft () {
      this.axios
        .get(`/draft/requirement/${this.requerimiento.requirementDefinition}`)
        .then(response => {
          this.currentRequerimiento = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    updateAfterRequest (response) {
      this.hideDialog()
      this.$emit('updateRequerimiento', response)
    },
    hideDialog () {
      this.$emit('hideDialog')
    }
  },

  mounted () {
    if (this.requerimiento.isInDraft) {
      this.fetchRequerimientoDraft()
    } else {
      this.currentRequerimiento = this.requerimiento
      this.loading = false
    }
  }
}
</script>

<style scoped>
.custom-font-regular {
  font-family: SourceSansProRegular, sans-serif;
}
.body-content {
  padding: 0 0.5em 0 0.5em;
  background-color: #e9eaec;
}
</style>
